import { styled } from '@mui/material';

import { ChkDrawer } from '@ui/checkout-components';

import type { DrawerProps } from './Drawer.types';

export function Drawer({ children, ...props }: DrawerProps) {
  return (
    <DrawerContainer
      hideBackdrop
      open
      variant="persistent"
      sx={{ zIndex: 2 }}
      overlayMode={false}
      {...props}
    >
      <Wrapper>{children}</Wrapper>
    </DrawerContainer>
  );
}

const DrawerContainer = styled(ChkDrawer)(({ theme }) => ({
  borderRadius: `${theme.borders.borderRadius3} ${theme.borders.borderRadius3} ${theme.borders.borderRadius2} ${theme.borders.borderRadius2}`,

  '& .MuiDrawer-paper': {
    backgroundColor: theme.tokens.bottomSheetBackgroundSurface,
  },
}));

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '100%',
  padding: theme.spacing(5, 6, 7),
}));
